<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<div class="content" role="main">
  <app-shell>
    <router-outlet></router-outlet>
  </app-shell>
</div>
